import i18n from 'i18n'
import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    { label: 'Desktop', value: 1 },
    { label: 'Mobile', value: 2 },
    { label: 'App', value: 3 },
]

// Display-only: el value (id) es la identidad que envía el form; solo se traduce el texto mostrado.
const DEVICE_KEY = { 1: 'common:filters.deviceWeb', 2: 'common:filters.deviceMobile', 3: 'common:filters.deviceApp' }

export default function SelectDeviceStatic({...props}) {
    const myProps = {
        placeholder: i18n.t('common:filters.allDevices'),
        formatOptionLabel: opt => i18n.t(DEVICE_KEY[opt?.value] || '', { defaultValue: opt?.label }),
        firstSelect: true,
        isClearable: false,
        options: OPTIONS,
        icon: { icon: 'phone-laptop' },
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}